import { createContext, useContext, useEffect, useState } from 'react';
import { AddProductToLastWatched, GetLastWatchedProducts } from '../Services/ProductService';
import { useConfig } from './ConfigProvider';
import { useAuth } from './AuthProvider';

const LastWatchedProductsContext = createContext()

export const useLastWatchedProducts = () => {
    return useContext(LastWatchedProductsContext)
}

export const LastWatchedProductsProvider = ({ children }) => {
    const { authState } = useAuth();
    const [lastWatchedProducts, setLastWatchedProducts] = useState([])

    const { api } = useConfig();

    const addProductToLastWatched = async (artNo) => {
        try {
            if (!validateArtNo(artNo)) {
                return false
            }
            await AddProductToLastWatched(api, artNo)
            getLastWatchedProducts()
            return true
        } catch (error) {
            console.log("Error podcas dodawania: " + error)
            return false
        }
    }

    const validateArtNo = (value) => {
        if (value === null || value === undefined || value === '') {
            return false
        }
        return true
    }

    useEffect(() => {
        if (authState.user != null) {
            getLastWatchedProducts()
        }
    }, [authState])

    const getLastWatchedProducts = async () => {
        try {
            const result = await GetLastWatchedProducts(api, authState.custId, authState.siteId, authState.whId)
            setLastWatchedProducts(result.data)
        } catch (e) {
            console.log(e)
            setLastWatchedProducts([])
        }
    }


    return (
        <LastWatchedProductsContext.Provider value={{ addProductToLastWatched, getLastWatchedProducts, lastWatchedProducts }}>
            {children}
        </LastWatchedProductsContext.Provider>
    )
}